import Vue from 'vue'
import axios from 'axios'

const attack = (data) => {
  if (!data) return
  let token = {}
  if (sessionStorage.publicToken) {
    token.Authorization = `Bearer ${sessionStorage.publicToken}`
  }
  let newUrl = `${data.url}?mathId=${Math.random()}`
  if (data.type == 'get') {
    axios.get(newUrl, {
      params: data.data,
      headers: token
    }).then((res) => {
      data.success && data.success.call(this, res)
    }).catch((err) => {
      data.error && data.error.call(this, err.response.data)
    })
  } else {
    axios.post(newUrl, data.data, {
      headers: token
    }).then((res) => {
      data.success && data.success.call(this, res)
    }).catch((err) => {
      // console.log(err)
      data.error && data.error.call(this, err.response.data)
      // data.error
    })
  }
}
Vue.prototype.$http = attack

export default attack



// WEBPACK FOOTER //
// ./src/request/request.js